import React from 'react'

const PrsInformation = ({ genomeBuild, productItem }) => {
  return (
    <div className="p-3 bg-white">
      {/* <div className="mb-3">
        <h6 className="mb-0 fw-bold" style={{ fontSize: '13px', letterSpacing: '1px' }}>
          PRS Information
        </h6>
        <hr className="mt-2 mb-3" />
      </div> */}
      <ul className="list-unstyled mb-0 text-gray-700">
        <li className="mb-2 d-flex">
          <span className="fw-semibold w-50">Genome Build:</span>
          <span>{genomeBuild}</span>
        </li>
        <li className="mb-2 d-flex">
          <span className="fw-semibold w-50">Barcode:</span>
          <span>{productItem.barcode}</span>
        </li>
        <li className="mb-2 d-flex">
          <span className="fw-semibold w-50">Kit Name:</span>
          <span>{productItem.kit?.name}</span>
        </li>
        <li className="d-flex">
          <span className="fw-semibold w-50">Presets Count:</span>
          <span>5</span>
        </li>
      </ul>
    </div>
  )
}

export { PrsInformation }
